import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { InspectionAirConditioningAndVentilationSystems } from '@authority-labs/api-interfaces';
import { Base1001TestResultsComponent } from '../../base-1001-certificate';

@Component({
  selector:
    'authority-labs-air-conditioning-and-ventilation-systems-test-results',
  templateUrl:
    './air-conditioning-and-ventilation-systems-test-results.component.html',
  styleUrls: [
    './air-conditioning-and-ventilation-systems-test-results.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class AirConditioningAndVentilationSystemsTestResultsComponent
  extends Base1001TestResultsComponent
  implements OnInit
{
  @Input() inspection: InspectionAirConditioningAndVentilationSystems;

  ngOnInit(): void {
    this.init(
      this.inspection.cases,
      new InspectionAirConditioningAndVentilationSystems(
        this.inspection
      ).getNotes()
    );
  }
}
